import styled from 'styled-components';

export const TreeContainer = styled.div`
	background-color: ${props => props.color};
	width: 100%;
	height: 8%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	position: fixed;
	top: 0;
	// backdrop-filter: blur(0.5px);
	// -webkit-backdrop-filter: blur(0.5px);
	z-index: 10;
	overflow: hidden;

	// background-color: #f8f9fa; /* Default color */
	// color: #333;
	// padding: 20px;
	// position: sticky;
	// top: 0;
	// z-index: 1000;
	// transition: background-color 0.3s ease;

	.tree {
		color: white;
		text-shadow: black 0px 0px 10px;
		font-weight: bold;
		font-size: ${window.screen.width <= 1000 ? '1.2rem' : '1.8rem'};
		letter-spacing:  ${window.screen.width <= 1000 ? '5px' : '10px'};
		width: auto;
		height: 100%;
		position: relative;
		left: ${window.screen.width <= 1000 ? '15px' : '40px'};


		&:hover {
		  cursor: pointer;
	      transition: transform 0.5s cubic-bezier(0.25, 0.45, 0.45, 0.95);
		};
	}

	svg {
		filter: drop-shadow(0px 0px 10px black);
		position: relative;
		right: ${window.screen.width <= 1000 ? '15px' : '50px'};
		height: 100%;
	}

`;